// extracted by mini-css-extract-plugin
export default {"outer":"Music_outer__UTYT4","embed_responsive":"Music_embed_responsive__AuGlK"};